<div>
  <h1 class="app">Program Guidelines</h1>
</div>

@for (programTile of programTiles; track programTile) {
  <div class="startAQuote">
    <div class="w-full flex title-wrapper">
      <h2 class="app">{{ programTile.sectionHeader }}</h2>
    </div>


    <div class="w-full flex flex-col lg:flex-row gap-4 lg:gap-[2.5rem] mt-4">
      @for (tile of programTile.programTiles; track tile) {
        <div class="w-full lg:w-1/3">
          <div class="program-tile">
            <div class="logo">
              <img src="{{ tile.imageUrl }}" alt="{{ programTile.heading || 'Program Tile' }}" />
            </div>
            <p class="large bold mt-3">{{ tile.heading }}</p>
            <ul>
              @for(item of getListItems(tile.subHeading); track item ) {
                <li>
                  {{ item }}
                </li>
              }
            </ul>

            @if (tile.showButton) {
              <div class="py-5">
                <lib-button [cssType]="'btn-secondary'" [buttonType]="'link'" [text]="'View Program Guidelines'" [size]="'small'" [routerLink]="'/program-guidelines/rcip'" ></lib-button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- <div class="cta-section mt-5">
<div>
  <h2 class="app">CTA or Ad?</h2>
  <p>
    Lorem description.
  </p>
</div>
<div>
  <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'"  [text]="'CTA'" [size]="'large'"  (click)="toggleAdvertisement()"></lib-button>
</div>
</div> -->


